import { createTheme, MantineColorsTuple } from '@mantine/core';

const nhiBlue: MantineColorsTuple = [
  '#e6f2ff',
  '#cce3ff',
  '#99c7ff',
  '#66aaff',
  '#338eff',
  '#0071ff',
  '#005ce6',
  '#0047b3',
  '#003280',
  '#001d4d',
];

export const theme = createTheme({
  primaryColor: 'nhiBlue',
  colors: {
    nhiBlue,
  },
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  headings: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
});
